import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { CenteredLoader } from './CenteredLoader';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  loader: ({ fixed, transparent, fade }: Props) => ({
    ...theme.absoluteFill,
    backgroundColor: transparent
      ? 'transparent'
      : theme.basicColors.white.fade(fade || 0).toString(),
    zIndex: 1,
    position: fixed ? 'fixed' : 'absolute',
  }),
}));

interface Props {
  transparent?: boolean;
  fixed?: boolean;
  fade?: number;
  message?: string;
  noMessage?: boolean;
}

export const OverlayLoader = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <CenteredLoader
      className={classes.loader}
      message={props.message}
      noMessage={props.noMessage}
    />
  );
};
